import type { AppData, SerializeFrom } from "@remix-run/node";
// eslint-disable-next-line no-restricted-imports -- This file is the fix for the untyped useRouteLoaderData.
import { useRouteLoaderData as useRouteLoaderDataRR } from "@remix-run/react";

export function useRouteLoaderData<T = AppData>(routeId: string): SerializeFrom<T> {
  return useRouteLoaderDataRR(routeId) as SerializeFrom<T>;
}
